import React, { useState } from 'react';
import { Box, Button, Collapse, Grid, IconButton, Paper, Typography } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

interface FilterPanelProps {
    onClear: () => void;
    onSearch: () => void;
    // Ações extras antes de Limpar/Consultar (ex.: "Mais filtros")
    extraActions?: React.ReactNode;
    defaultOpen?: boolean;
    // Itens de Grid (<Grid item ...>) com os campos de filtro
    children: React.ReactNode;
}

// Filtros recolhíveis (fechados por padrão) com as ações Limpar/Consultar
export function FilterPanel({ onClear, onSearch, extraActions, defaultOpen = false, children }: FilterPanelProps) {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <Paper sx={{ p: 2 }}>
            <Box
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', borderRadius: 1, p: 1, ml: -1, mr: -1, mb: open ? 2 : 0, '&:hover': { backgroundColor: 'action.hover' } }}
                onClick={() => setOpen(!open)}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <FilterListIcon color="action" />
                    <Typography variant="h6" component="h2">Filtros</Typography>
                </Box>
                <IconButton size="small" sx={{ pointerEvents: 'none' }} aria-label={open ? 'Recolher filtros' : 'Expandir filtros'}>
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
            </Box>
            <Collapse in={open}>
                <Grid container spacing={1.5}>
                    {children}
                    <Grid item xs={12}>
                        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                            {extraActions}
                            <Button variant="outlined" color="secondary" startIcon={<ClearIcon />} onClick={onClear}>Limpar</Button>
                            <Button variant="contained" startIcon={<SearchIcon />} onClick={onSearch}>Consultar</Button>
                        </Box>
                    </Grid>
                </Grid>
            </Collapse>
        </Paper>
    );
}
